module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAATCAYAAABV/rckAAAAAXNSR0IArs4c6QAAADJJREFUCB1jYEACjBNmr2v9/58hj5GRYRILiPGfgYGHAUgzgUQYGRi+gGgkHUQzB5nRAJRyJTMCfUutAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/settings.png
// module id = 283
// module chunks = 0